module.exports = __webpack_public_path__ + "img/47.aa75441a.jpg";